import React, { useMemo, useState } from "react";
import { IconButton } from "../../components";
import AssetSearchPagedSelect from "../../components/forms/selects/AssetSearchPagedSelect";
import { Main, PageSubHeader, ThemedIcon, ThemedSpan } from "../../components/utilities";
import AssetPricesTable from "./components/AssetPricesTable";
import CreatePriceModal from "./components/CreatePriceModal";
import EditPriceModal from "./components/EditPriceModal";
import PricesManagementProvider, { usePricesManagement } from "./hooks/PricesManagementContext";

const PricesManagementHeader = ({ }) => {
    const { selectedAsset, setSelectedAsset, createResult } = usePricesManagement();
    const [showFilters, setShowFilters] = useState(false);
    const [showCreate, setShowCreate] = useState(false);
    const { data: asset } = selectedAsset || {};

    const disabled = useMemo(() => !selectedAsset || createResult.isLoading,
        [createResult.isLoading, selectedAsset]);
    
    return (
        <>
            <PageSubHeader>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <ThemedSpan variant={"primary"} className="h5 m-0">{asset?.longAssetName}</ThemedSpan>
                    </div>
                    <div className="d-flex flex-fill justify-content-end align-items-center gap-2">
                        <AssetSearchPagedSelect
                            className="w-50"
                            placeholder="Select Asset..."
                            valueObject={selectedAsset}
                            setValue={(value) => setSelectedAsset(value)}
                            disableAnimations
                            isClearable
                        />
                        <IconButton icon={"fa-plus"} variant="success" disabled={disabled} onClick={() => setShowCreate(true)}>
                            Create New Price
                        </IconButton>
                    </div>
                </div>
            </PageSubHeader>
            <CreatePriceModal
                show={showCreate}
                onHide={() => setShowCreate(false)}
            />
            <EditPriceModal/>
        </>
    );
};

export const PricesManagement = () => {

    return (
        <PricesManagementProvider>
            <Main className="d-flex flex-column">
                <PricesManagementHeader />
                <section className="px-4 my-3 h-100">
                    <AssetPricesTable />
                </section>
            </Main>
        </PricesManagementProvider>
    );
};



export default PricesManagement;